import { createUseQueryHook } from '@iheartjane/react-query-utils';

import { fetchCart, fetchUserCart } from './cart.api';
import type { Cart, FetchCartProps, FetchUserCartProps } from './cart.types';

const CART_BASE_KEY = 'cart';

export const cartKeys = {
  detail: (uuid: string, paymentMethod?: string): readonly string[] =>
    paymentMethod
      ? [CART_BASE_KEY, uuid, paymentMethod]
      : [CART_BASE_KEY, uuid],
  userCart: (appMode: string, storeId?: number | string, uuid?: string) =>
    [CART_BASE_KEY, 'user', appMode, storeId ?? null, uuid ?? null] as const,
};

export const useCart = createUseQueryHook<FetchCartProps, Cart>(
  fetchCart,
  ({ uuid, paymentMethod }) => cartKeys.detail(uuid, paymentMethod),
  ({ uuid }) => !!uuid
);

export const useUserCart = createUseQueryHook<FetchUserCartProps, Cart | null>(
  fetchUserCart,
  ({ appMode, storeId, uuid }) => cartKeys.userCart(appMode, storeId, uuid),
  // Mirrors the backend guard: a non-default app mode requires a store_id, or
  // the request is guaranteed to fail with InvalidQueryError.
  ({ appMode, storeId }) =>
    !!appMode && (appMode === 'default' || storeId != null)
);
